import React from 'react';
import { NavItemWrapper, NavItemLink, TabTitle, TabIcon } from './styled';
const TabItem = ({ tab, isActiveTab, handleItem }) => (React.createElement(NavItemWrapper, { className: "nav-item", id: `${tab.id}` },
    React.createElement(NavItemLink, { className: `nav-link tab-${tab.id} d-flex align-items-center ${isActiveTab ? 'active' : ''}`, onClick: () => handleItem(tab.id) },
        (tab.activeIcon || tab.inactiveIcon) && (React.createElement(TabIcon, { src: `${isActiveTab ? tab.activeIcon : tab.inactiveIcon}`, alt: tab.name, className: "tab-icon" })),
        React.createElement(TabTitle, { className: "tab-title" }, tab.name))));
export default TabItem;
